<script>
	import { page } from '$app/stores'
	import ContactBox from '$lib/components/contact-box/ContactBox.svelte'
	import Header from '$lib/components/header-2.0/Header.svelte'
	import { OtherArticlesV4 } from '$lib/modules/blog'
	import DynamicPageWrapper from '$lib/modules/cms/DynamicPageWrapper/DynamicPageWrapper.svelte'
	import Socials from '$lib/modules/contact/Socials.svelte'
	import { t } from '$lib/translations'
	import { Separator } from '$lib/ui-woltair/components'
	import Investors from './@modules/Investors.svelte'
	import OurTeam from './@modules/OurTeam.svelte'
	import { PUBLIC_WOLTAIR_WEB_CODE } from '$env/static/public'

	export let data

	const header = {
		heading: t('web.about_us.header.heading'),
		subheading: t('web.about_us.header.subheading'),
		main_image: {
			url: '/images/about/header-about.webp',
			alternativeText: t('web.about_us.header.imgAlt')
		}
	}

	const superfixImageUrl = {
		WOLTAIR_CZ: '/images/about/superfix-screenshot.webp',
		WOLTAIR_DE: '/images/about/superfix-screenshot.webp',
		WOLTAIR_PL: '/images/about/superfix-screenshot.webp',
		WOLTAIR_IT: '/images/about/superfix-screenshot-it.webp'
	}

	const aboutUsBlocks = [
		{
			locals: ['CS', 'PL', 'DE', 'IT'],
			heading: t('web.about_us.block1.heading'),
			text: t('web.about_us.block1.text'),
			image: {
				url:
					{
						WOLTAIR_CZ: '/images/about/brands.svg',
						WOLTAIR_PL: '/images/about/about-brands-pl.webp',
						WOLTAIR_DE: '/images/about/about-brands-de.webp',
						WOLTAIR_IT: '/images/about/brands.svg'
					}[PUBLIC_WOLTAIR_WEB_CODE] || '/images/about/brands.svg',
				alt: t('web.about_us.block1.imgAlt')
			}
		},
		{
			locals: ['CS'],
			heading: t('web.about_us.block2.heading'),
			text: t('web.about_us.block2.text'),
			image: {
				url: '/images/about/app.webp',
				alt: t('web.about_us.block2.imgAlt')
			}
		},
		{
			locals: ['DE'],
			heading: t('web.about_us.block2.heading'),
			text: t('web.about_us.block2.text'),
			image: {
				url: '/images/about/offer-screenshot.webp',
				alt: t('order.tabs.lead')
			}
		},
		{
			locals: ['CS', 'DE', 'IT'],
			heading: t('web.about_us.block3.heading'),
			text: t('web.about_us.block3.text'),
			image: {
				url: '/images/about/workers.webp',
				alt: t('web.about_us.block3.imgAlt')
			}
		},
		{
			locals: ['CS', 'PL'],
			heading: t('web.about_us.block5.heading'),
			text: t('web.about_us.block5.text'),
			image: {
				url: '/images/about/mobile.webp',
				alt: t('web.about_us.block5.imgAlt')
			}
		},
		{
			locals: ['DE', 'IT'],
			heading: t('web.about_us.block5.heading'),
			text: t('web.about_us.block5.text'),
			image: {
				url: superfixImageUrl[PUBLIC_WOLTAIR_WEB_CODE],
				alt: t('web.about_us.block6b.imgAlt')
			}
		},
		{
			locals: ['CS', 'DE', 'IT'],
			heading: t('web.about_us.block6.heading'),
			text: t('web.about_us.block6.text'),
			image: {
				url: '/images/persons/woltair-founders.webp',
				alt: t('web.about_us.block6.imgAlt')
			}
		}
	].filter((el) => el.locals.includes($page.data.organization.lang))

	const investors = {
		title: t('web.about_us.investors.title'),
		subtext: t('web.about_us.investors.subtext'),
		logos: [
			{
				locals: ['DE', 'IT'],
				url: '/images/logos/investors/arctern-ventures.svg',
				alt: 'ArcTern Ventures',
				cls: 'scale-110'
			},
			{
				locals: ['DE', 'IT'],
				url: '/images/logos/investors/the-westly-group.svg',
				alt: 'The Westly Group',
				cls: 'scale-90'
			},
			{
				locals: ['DE', 'IT'],
				url: '/images/logos/investors/kaya.svg',
				alt: 'Kaya',
				cls: ''
			},
			{
				locals: ['DE', 'IT'],
				url: '/images/logos/investors/inven-capital.svg',
				alt: 'Inven Capital',
				cls: ''
			},
			{
				locals: ['DE', 'IT'],
				url: '/images/logos/investors/presto-ventures.webp',
				alt: 'Presto Ventures',
				cls: ''
			}
		].filter((el) => el.locals.includes($page.data.organization.lang))
	}
</script>

{#if data.type === 'productPage' && data.components}
	<DynamicPageWrapper
		header={data.header}
		title={data.title}
		components={data.components}
		type={data.type}
	/>
{:else}
	<Header {header} showRightSlot wrapperCls="lg:pt-12">
		<svelte:fragment slot="right">
			<div class="mt-8 flex h-full w-full justify-center">
				<ContactBox />
			</div>
		</svelte:fragment>
	</Header>
	<div class="container-flex page-wrapper flex flex-col !gap-16 md:flex-row lg:!flex-nowrap">
		<div class="info flex flex-col items-center md:max-w-[40%] lg:max-w-[25%]">
			<div class="wrap">
				<h2 class="whitespace-nowrap">{t('web.about_us.stripe.box1.number')}</h2>
				<img src="/images/about/icon-topeni.svg" alt={t('web.about_us.stripe.box1.imgAlt')} />
			</div>
			<p class="text text-center text-1.5xl font-light">{t('web.about_us.stripe.box1.text')}</p>
		</div>
		<div class="info flex flex-col items-center md:max-w-[40%] lg:max-w-[25%]">
			<div class="wrap">
				<h2 class="whitespace-nowrap">{t('web.about_us.stripe.box2.number')}</h2>
				<img src="/images/about/icon-house.svg" alt={t('web.about_us.stripe.box2.imgAlt')} />
			</div>
			<p class="text text-center text-1.5xl font-light">{t('web.about_us.stripe.box2.text')}</p>
		</div>
		<div class="info flex flex-col items-center md:max-w-[40%] lg:max-w-[25%]">
			<div class="wrap">
				<h2 class="whitespace-nowrap">{t('web.about_us.stripe.box3.number')}</h2>
				<img src="/images/about/icon-worker.svg" alt={t('web.about_us.stripe.box3.imgAlt')} />
			</div>
			<p class="text text-center text-1.5xl font-light">{t('web.about_us.stripe.box3.text')}</p>
		</div>
		<div class="info flex flex-col items-center md:max-w-[40%] lg:max-w-[25%]">
			<div class="wrap">
				<h2 class="text-green whitespace-nowrap">
					{t('web.about_us.stripe.box4.number')}
				</h2>
				<img src="/images/about/icon-flower.svg" alt={t('web.about_us.stripe.box4.imgAlt')} />
			</div>
			<p class="text text-center text-1.5xl font-light">{t('web.about_us.stripe.box4.text')}</p>
		</div>
	</div>

	<Investors {investors} />

	{#each aboutUsBlocks as block}
		<div class="box page-wrapper pt-10">
			<div class="img-cont">
				<img src={block?.image?.url} alt={block?.image?.alt} />
			</div>
			<div class="text-cont left">
				<h2>{@html block?.heading}</h2>
				<p>{@html block?.text}</p>
			</div>
		</div>
	{/each}

	<section class="page-wrapper">
		{#if data.otherArticles?.length}
			<OtherArticlesV4 otherArticles={data.otherArticles} />
		{/if}
	</section>

	{#if data.showroom}
		<section class="background-full page-fullwidth bg-neutral-100">
			<div class="cont flex w-full flex-col gap-12 lg:flex-row lg:gap-20">
				<div class="w-full lg:w-1/2">
					<Separator align="left" />
					<h2>{t('web.about_us.showroom.heading')}</h2>
					<p class="text-neutral-500">
						{t('web.about_us.showroom.text')}
					</p>
					<div class="box-contact my-6">
						<img src="/images/icons/icon-map.svg" alt={t('web.about_us.showroom.map')} />
						<div>
							<p>{data.showroom?.address}</p>
							<a href={data.showroom?.mapUrl} class="text-primary-500 hover:underline">
								{t('web.about_us.showroom.map')}
							</a>
						</div>
					</div>
					<div class="mt-3 text-neutral-500">
						<p>{t('web.about_us.showroom.callUs')}</p>
						<div class="mb-2 mt-1">
							<a href={data.contact?.phoneRef} class="font-semibold text-primary-500"
								>{data.contact?.phoneNum}</a
							>
						</div>
					</div>
				</div>
				<div class="right !w-full">
					<img src="/images/persons/woltair-people.webp" alt={t('web.about_us.showroom.imgAlt')} />
				</div>
			</div>
		</section>
	{/if}

	{#if PUBLIC_WOLTAIR_WEB_CODE == 'WOLTAIR_DE' || PUBLIC_WOLTAIR_WEB_CODE == 'WOLTAIR_IT'}
		<section class="page-wrapper">
			<OurTeam />
		</section>
	{/if}

	{#if data.representative}
		<section class="background-full md:page-wrapper">
			<div class="cont-feedback">
				<Separator />
				<h2 class="mb-1 text-center">{t('web.about_us.endBox.heading')}</h2>
				<p class="text-center text-neutral-500">{t('web.about_us.endBox.text')}</p>
				<div class="wrapper my-10">
					<div class="left !mt-2 flex">
						<img
							class="max-w-sm"
							src={data.representative?.imageUrl}
							alt={data.representative?.name}
						/>
						<div class="box-contact align-start no-shadow m-0 mt-0 pt-0">
							<div>
								<h3 class="!mt-0 mb-1">{data.representative?.name}</h3>
								<p class="text-neutral-500">{data.representative?.position}</p>
								<a
									href={`mailto:${data.representative?.mail}`}
									class="font-font-semibold text-primary-500">{data.representative?.mail}</a
								>
							</div>
						</div>
					</div>
					<div class="right">
						<Socials />
					</div>
				</div>
			</div>
		</section>
	{/if}
{/if}

<style lang="scss">
	h2 {
		font-weight: 800 !important;
	}

	.container-flex {
		display: flex;
		justify-content: space-between;
		padding-bottom: 60px;
		//border-bottom: 1px solid #ccc;
		position: relative;
		z-index: 2;
		flex-wrap: wrap;
		align-items: center;

		@media only screen and (min-width: 768px) {
			margin-top: 0;
		}

		.info {
			display: flex;
			flex-direction: column;
			align-items: center;

			@media only screen and (min-width: 640px) {
				width: 50%;
			}

			@media only screen and (min-width: 1024px) {
				width: fit-content;
				align-items: left;
			}

			.wrap {
				display: flex;
				align-items: flex-end;

				h2 {
					margin-bottom: 0;
					margin-right: 15px;
				}
			}

			.text {
				color: #666;
			}
		}
	}

	.box {
		display: flex;
		margin: 50px 0;
		@media only screen and (max-width: 760px) {
			flex-direction: column;
		}

		.text-cont {
			width: 50%;
			padding-left: 100px;

			@media only screen and (max-width: 760px) {
				width: 100%;
				padding-left: 0;
			}

			h2 {
				margin-top: 0;
			}
			p {
				line-height: 32px;

				:global(a) {
					color: #e20613;
				}
			}
		}

		.img-cont {
			width: 50%;
			overflow: hidden;
			display: block;

			@media only screen and (max-width: 760px) {
				width: 100%;
				position: relative;
				width: 100vw;
				left: -15px;
				margin-bottom: 20px;
			}

			img {
				width: 100%;
				display: block;
				height: auto;
			}
		}

		&:nth-child(even) {
			flex-direction: row-reverse;

			@media only screen and (max-width: 760px) {
				flex-direction: column;
			}

			.text-cont {
				padding: 0 100px 0 0;

				@media only screen and (max-width: 760px) {
					padding: 0;
				}
			}
		}
	}

	.cont {
		max-width: 1360px;
		margin: 0 auto;
		padding: 50px 15px;
		display: flex;

		.right {
			width: 60%;

			@media only screen and (max-width: 760px) {
				width: 100%;
			}

			img {
				width: 100%;
				display: block;
			}
		}
	}

	.box-contact {
		display: flex;
		padding: 20px;
		align-items: center;
		box-shadow: 0 0 30px 0 rgba(0, 0, 0, 0.175);
		border-radius: 5px;

		&.no-shadow {
			box-shadow: none;
		}

		img {
			margin-right: 20px;
		}

		div {
			p {
				margin-top: 0;
				margin-bottom: 5px;
			}
		}
	}

	.flex {
		display: flex;
	}

	.cont-feedback {
		max-width: 1360px;
		margin: 0 auto;
		padding: 50px 15px;

		.wrapper {
			display: flex;
			justify-content: space-evenly;

			@media only screen and (max-width: 760px) {
				flex-direction: column;
			}

			.left {
				@media only screen and (max-width: 1024px) {
					flex-direction: column;
					width: 100%;
				}

				img {
					@media only screen and (max-width: 760px) {
						position: relative;
						width: 100vw;
						margin-bottom: 20px;
					}
				}
			}
		}
	}
</style>
